module.exports = __webpack_public_path__ + "static/small_homepage-859b780beb62cf446f4d7ac49e936620.svg";